<template>
    <div>
      <Head>
        <title>{{(category) ? category +' jobs in Ireland' : 'Jobs in Ireland'}}</title>
        <link rel="canonical" :href="'https://backtoworkconnect.ie/courses/'+category_alias" />
        <meta head-key="description" name="description" :content="'Discover rewarding opportunities in ' + category + ' when returning to the workforce in Ireland. Take the first step toward a fulfilling career journey in ' + category + ' with Returner Friendly employer'" />

      </Head>
      <v-container class="">
        <v-card>
            <BackButton></BackButton>
            <v-container class="grey lighten-5" v-if="!expandSearch">
                <v-row>
                    <v-col cols=12 sm="12" lg="12" class="p-0" >
                        <v-text-field 
                             
                            label="Search" 
                            v-model="search.keywords" 
                            prepend-icon="mdi-magnify" 
                            @focus="expandSearch = true"></v-text-field>
                    </v-col>    
                </v-row>    
            </v-container>
            <template v-if="expandSearch">
                <TabbedSearch  :clearbg="true" startTab="jobs" :startOpen="startOpen" :baseurl="baseurl" :locations="locations" :categories="categories" :startKeyword="keywords" :startLocation="location" :startCategory="category"></TabbedSearch>
            </template>
        </v-card>
        
        <h2 class="m-3">Your search for <span v-if="category">{{category}} - </span><span v-if="keywords">"{{keywords}}"</span><span v-else>jobs</span> in {{location}} returned {{jobs.total}} result(s).</h2>
        <h1>Jobs in Ireland</h1>
        <JobCard :key="j.id" v-for="j in jobs.data" :job="j" :auth="auth" :state="state" :baseurl="baseurl" :prevurl="prevurl" 
        @toggleComponentLogin="toggleComponentLogin($event)">
        </JobCard>
        <br/><br/>
        <Pagination :links="jobs.links"></Pagination>
      </v-container>
      
    </div>
</template>
<script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import JobCard from '@/Shared/JobCard'
  import BackButton from '@/Shared/BackButton'
  import axios from 'axios'
  import Pagination from '@/Shared/Pagination'

  import TabbedSearch from '@/Shared/TabbedSearch'

  export default {
    props: {
      category_alias: String,
      title: String,
      jobs: Object,
      auth: Object,
      state: String,
      baseurl: String,
      prevurl: String,
      location: String,
      category: String,
      keywords: String,
      locations: Array,
      categories: Array,
      startOpen: Boolean
    },
    components: {
      Head,
      JobCard,
      Pagination,
      TabbedSearch,
      BackButton
    },
    layout: Layout,
    data() {
        return {
            applyDialog: false,
            expandSearch: this.startOpen,
            search: {
                location: this.location ? this.location : '',
                category: this.category ? this.category : '',
                keywords: this.keywords ? this.keywords : '',
            }
        }
    },
    watch: {
    },
    created() {
        if (this.keywords)
            this.search.keywords = this.keywords
    },
    mounted() {
        this.search.keywords = (!this.keywords || this.keywords =='jobs') ? '' : this.keywords
        this.search.location = (!this.location || this.location=='Ireland') ? '' : this.location
        this.search.category = this.category
    },
    methods: {
        toggleComponentLogin(e) {
            console.log('results triggering login',e)
            if (!this.auth.user)
                this.$parent.$emit('toggleComponentLogin',e);
        
        },
        searchJobs() {
            this.$inertia.get(this.baseurl+'/search/job', {keyword: this.search.keywords, location: this.search.location, category: this.search.category}, {

            }) 
        }
    },
  }
  </script>
  
  <style>
    .fixedFooter {
        margin-top:50px;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    }
    </style>